module.exports = __webpack_public_path__ + "img/isvIntroductionService.9db3458c.png";